(() => {

      var $parcel$global = globalThis;
    
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea7df"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea7df"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("3fmZL", function(module, exports) {
const marketSelectors = document.querySelectorAll(".market-selector-wrapper");
if (marketSelectors.length === 0) return;
marketSelectors.forEach((selector)=>{
    const currentMarketDisplay = selector.querySelector(".current-market-display");
    const marketOptionsList = selector.querySelector(".market-options-list");
    const marketOptions = selector.querySelectorAll(".market-option");
    const form = selector.querySelector("form");
    const languageInput = form?.querySelector('input[name="language_code"]');
    const countryInput = form?.querySelector('input[name="country_code"]');
    marketOptions.forEach((option)=>{
        option.addEventListener("click", function(e) {
            e.preventDefault();
            if (form && languageInput && countryInput) {
                const marketIso = this.dataset.countryIso;
                const languageCode = this.dataset.languageIso;
                if (languageCode && marketIso) {
                    languageInput.value = languageCode;
                    countryInput.value = marketIso;
                    form.submit();
                }
            }
        });
    });
    function openDropdown() {
        marketSelectors.forEach((otherSelector)=>{
            if (otherSelector !== selector) {
                const otherMarketOptionsList = otherSelector.querySelector(".market-options-list");
                const otherCurrentMarketDisplay = otherSelector.querySelector(".current-market-display");
                otherMarketOptionsList.classList.remove("show");
                otherCurrentMarketDisplay.classList.remove("active");
                otherCurrentMarketDisplay.setAttribute("aria-expanded", "false");
            }
        });
        marketOptionsList.classList.add("show");
        currentMarketDisplay.classList.add("active");
        currentMarketDisplay.setAttribute("aria-expanded", "true");
        if (marketOptions.length > 0) {
            const selectedOption = marketOptionsList.querySelector(".market-option.selected") || marketOptions[0];
            selectedOption.focus();
        }
    }
    function closeDropdown() {
        marketOptionsList.classList.remove("show");
        currentMarketDisplay.classList.remove("active");
        currentMarketDisplay.setAttribute("aria-expanded", "false");
        currentMarketDisplay.focus();
    }
    currentMarketDisplay.addEventListener("click", function() {
        if (marketOptionsList.classList.contains("show")) closeDropdown();
        else openDropdown();
    });
    currentMarketDisplay.addEventListener("keydown", function(e) {
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            if (marketOptionsList.classList.contains("show")) closeDropdown();
            else openDropdown();
        } else if (e.key === "ArrowDown" && !marketOptionsList.classList.contains("show")) {
            e.preventDefault();
            openDropdown();
        }
    });
    marketOptionsList.addEventListener("keydown", function(e) {
        const focusedOption = document.activeElement;
        if (!focusedOption || !focusedOption.classList.contains("market-option") || !marketOptionsList.contains(focusedOption)) return;
        const currentIndex = Array.from(marketOptions).indexOf(focusedOption);
        if (e.key === "ArrowDown") {
            e.preventDefault();
            if (currentIndex < marketOptions.length - 1) marketOptions[currentIndex + 1].focus();
            else marketOptions[0].focus();
        } else if (e.key === "ArrowUp") {
            e.preventDefault();
            if (currentIndex > 0) marketOptions[currentIndex - 1].focus();
            else marketOptions[marketOptions.length - 1].focus();
        }
    });
});
document.addEventListener("click", function(event) {
    marketSelectors.forEach((selector)=>{
        const currentMarketDisplay = selector.querySelector(".current-market-display");
        const marketOptionsList = selector.querySelector(".market-options-list");
        if (marketOptionsList.classList.contains("show") && !selector.contains(event.target)) {
            marketOptionsList.classList.remove("show");
            currentMarketDisplay.classList.remove("active");
            currentMarketDisplay.setAttribute("aria-expanded", "false");
        }
    });
});
document.addEventListener("keydown", function(event) {
    if (event.key === "Escape") marketSelectors.forEach((selector)=>{
        const currentMarketDisplay = selector.querySelector(".current-market-display");
        const marketOptionsList = selector.querySelector(".market-options-list");
        if (marketOptionsList.classList.contains("show")) {
            marketOptionsList.classList.remove("show");
            currentMarketDisplay.classList.remove("active");
            currentMarketDisplay.setAttribute("aria-expanded", "false");
            currentMarketDisplay.focus();
        }
    });
});

});

parcelRegister("ilxwZ", function(module, exports) {
const cartContainer = document.getElementById("Cart-Drawer");
let upsellTriggered = false;
if (!cartContainer) return;
cartContainer.addEventListener("click", function(e) {
    const button = e.target.closest("#checkoutFormMob");
    if (!button) return;
    validateAndProceed();
});
cartContainer.addEventListener("click", function(e) {
    const button = e.target.closest("product-recommendations .side-panel-close");
    if (!button) return;
    document.getElementById("cart-drawer--recommendations--container").style.display = "none";
});
function validateAndProceed() {
    let termsCheckbox = document.getElementById("CartDrawerTerms");
    if (!termsCheckbox) return;
    if (termsCheckbox.checked) {
        showUpsell();
        upsellTriggered = true;
    } else {
        let checkoutForm = document.getElementById("checkoutForm");
        if (!checkoutForm) return;
        checkoutForm.click();
    }
    function showUpsell() {
        let showCartUpsell = document.getElementById("cart-drawer--recommendations--container");
        if (!showCartUpsell) return;
        if (!document.querySelector(".recommended-product") || upsellTriggered) document.querySelector("#showRecommendationsButton").click();
        else if (!upsellTriggered) {
            showCartUpsell.style.display = "block";
            upsellTriggered = true;
        } else {
            showCartUpsell.style.display = "none";
            upsellTriggered = true;
        }
    }
}

});

if (typeof window.Shopify == "undefined") window.Shopify = {};
if (typeof window.Shopify.functions == "undefined") window.Shopify.functions = {};
localStorage.setItem("isDonationDisabledTriggered", false);


"use strict";
function $93b0f01b05e2607a$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}


"use strict";
// utils is a library of generic helper functions non-specific to axios
const { toString: $aace3e920a0f1e4d$var$toString } = Object.prototype;
const { getPrototypeOf: $aace3e920a0f1e4d$var$getPrototypeOf } = Object;
const $aace3e920a0f1e4d$var$kindOf = ((cache)=>(thing)=>{
        const str = $aace3e920a0f1e4d$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $aace3e920a0f1e4d$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$aace3e920a0f1e4d$var$kindOf(thing) === type;
};
const $aace3e920a0f1e4d$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $aace3e920a0f1e4d$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $aace3e920a0f1e4d$var$isUndefined = $aace3e920a0f1e4d$var$typeOfTest("undefined");
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $aace3e920a0f1e4d$var$isBuffer(val) {
    return val !== null && !$aace3e920a0f1e4d$var$isUndefined(val) && val.constructor !== null && !$aace3e920a0f1e4d$var$isUndefined(val.constructor) && $aace3e920a0f1e4d$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $aace3e920a0f1e4d$var$isArrayBuffer = $aace3e920a0f1e4d$var$kindOfTest("ArrayBuffer");
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $aace3e920a0f1e4d$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $aace3e920a0f1e4d$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $aace3e920a0f1e4d$var$isString = $aace3e920a0f1e4d$var$typeOfTest("string");
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $aace3e920a0f1e4d$var$isFunction = $aace3e920a0f1e4d$var$typeOfTest("function");
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $aace3e920a0f1e4d$var$isNumber = $aace3e920a0f1e4d$var$typeOfTest("number");
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $aace3e920a0f1e4d$var$isObject = (thing)=>thing !== null && typeof thing === "object";
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $aace3e920a0f1e4d$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $aace3e920a0f1e4d$var$isPlainObject = (val)=>{
    if ($aace3e920a0f1e4d$var$kindOf(val) !== "object") return false;
    const prototype = $aace3e920a0f1e4d$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $aace3e920a0f1e4d$var$isDate = $aace3e920a0f1e4d$var$kindOfTest("Date");
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $aace3e920a0f1e4d$var$isFile = $aace3e920a0f1e4d$var$kindOfTest("File");
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $aace3e920a0f1e4d$var$isBlob = $aace3e920a0f1e4d$var$kindOfTest("Blob");
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $aace3e920a0f1e4d$var$isFileList = $aace3e920a0f1e4d$var$kindOfTest("FileList");
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $aace3e920a0f1e4d$var$isStream = (val)=>$aace3e920a0f1e4d$var$isObject(val) && $aace3e920a0f1e4d$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $aace3e920a0f1e4d$var$isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === "function" && thing instanceof FormData || $aace3e920a0f1e4d$var$isFunction(thing.append) && ((kind = $aace3e920a0f1e4d$var$kindOf(thing)) === "formdata" || // detect form-data instance
    kind === "object" && $aace3e920a0f1e4d$var$isFunction(thing.toString) && thing.toString() === "[object FormData]"));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $aace3e920a0f1e4d$var$isURLSearchParams = $aace3e920a0f1e4d$var$kindOfTest("URLSearchParams");
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $aace3e920a0f1e4d$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $aace3e920a0f1e4d$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($aace3e920a0f1e4d$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $aace3e920a0f1e4d$var$findKey(obj, key) {
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $aace3e920a0f1e4d$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : $parcel$global;
})();
const $aace3e920a0f1e4d$var$isContextDefined = (context)=>!$aace3e920a0f1e4d$var$isUndefined(context) && context !== $aace3e920a0f1e4d$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $aace3e920a0f1e4d$var$merge() {
    const { caseless: caseless } = $aace3e920a0f1e4d$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && $aace3e920a0f1e4d$var$findKey(result, key) || key;
        if ($aace3e920a0f1e4d$var$isPlainObject(result[targetKey]) && $aace3e920a0f1e4d$var$isPlainObject(val)) result[targetKey] = $aace3e920a0f1e4d$var$merge(result[targetKey], val);
        else if ($aace3e920a0f1e4d$var$isPlainObject(val)) result[targetKey] = $aace3e920a0f1e4d$var$merge({}, val);
        else if ($aace3e920a0f1e4d$var$isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $aace3e920a0f1e4d$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $aace3e920a0f1e4d$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $aace3e920a0f1e4d$var$forEach(b, (val, key)=>{
        if (thisArg && $aace3e920a0f1e4d$var$isFunction(val)) a[key] = (0, $93b0f01b05e2607a$export$2e2bcd8739ae039)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $aace3e920a0f1e4d$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $aace3e920a0f1e4d$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, "super", {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $aace3e920a0f1e4d$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $aace3e920a0f1e4d$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $aace3e920a0f1e4d$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $aace3e920a0f1e4d$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($aace3e920a0f1e4d$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$aace3e920a0f1e4d$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $aace3e920a0f1e4d$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== "undefined" && $aace3e920a0f1e4d$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $aace3e920a0f1e4d$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[Symbol.iterator];
    const iterator = generator.call(obj);
    let result;
    while((result = iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $aace3e920a0f1e4d$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $aace3e920a0f1e4d$var$isHTMLForm = $aace3e920a0f1e4d$var$kindOfTest("HTMLFormElement");
const $aace3e920a0f1e4d$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $aace3e920a0f1e4d$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $aace3e920a0f1e4d$var$isRegExp = $aace3e920a0f1e4d$var$kindOfTest("RegExp");
const $aace3e920a0f1e4d$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $aace3e920a0f1e4d$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $aace3e920a0f1e4d$var$freezeMethods = (obj)=>{
    $aace3e920a0f1e4d$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($aace3e920a0f1e4d$var$isFunction(obj) && [
            "arguments",
            "caller",
            "callee"
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$aace3e920a0f1e4d$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ("writable" in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
const $aace3e920a0f1e4d$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $aace3e920a0f1e4d$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $aace3e920a0f1e4d$var$noop = ()=>{};
const $aace3e920a0f1e4d$var$toFiniteNumber = (value, defaultValue)=>{
    value = +value;
    return Number.isFinite(value) ? value : defaultValue;
};
const $aace3e920a0f1e4d$var$ALPHA = "abcdefghijklmnopqrstuvwxyz";
const $aace3e920a0f1e4d$var$DIGIT = "0123456789";
const $aace3e920a0f1e4d$var$ALPHABET = {
    DIGIT: $aace3e920a0f1e4d$var$DIGIT,
    ALPHA: $aace3e920a0f1e4d$var$ALPHA,
    ALPHA_DIGIT: $aace3e920a0f1e4d$var$ALPHA + $aace3e920a0f1e4d$var$ALPHA.toUpperCase() + $aace3e920a0f1e4d$var$DIGIT
};
const $aace3e920a0f1e4d$var$generateString = (size = 16, alphabet = $aace3e920a0f1e4d$var$ALPHABET.ALPHA_DIGIT)=>{
    let str = "";
    const { length: length } = alphabet;
    while(size--)str += alphabet[Math.random() * length | 0];
    return str;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $aace3e920a0f1e4d$var$isSpecCompliantForm(thing) {
    return !!(thing && $aace3e920a0f1e4d$var$isFunction(thing.append) && thing[Symbol.toStringTag] === "FormData" && thing[Symbol.iterator]);
}
const $aace3e920a0f1e4d$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($aace3e920a0f1e4d$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!("toJSON" in source)) {
                stack[i] = source;
                const target = $aace3e920a0f1e4d$var$isArray(source) ? [] : {};
                $aace3e920a0f1e4d$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$aace3e920a0f1e4d$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const $aace3e920a0f1e4d$var$isAsyncFn = $aace3e920a0f1e4d$var$kindOfTest("AsyncFunction");
const $aace3e920a0f1e4d$var$isThenable = (thing)=>thing && ($aace3e920a0f1e4d$var$isObject(thing) || $aace3e920a0f1e4d$var$isFunction(thing)) && $aace3e920a0f1e4d$var$isFunction(thing.then) && $aace3e920a0f1e4d$var$isFunction(thing.catch);
var $aace3e920a0f1e4d$export$2e2bcd8739ae039 = {
    isArray: $aace3e920a0f1e4d$var$isArray,
    isArrayBuffer: $aace3e920a0f1e4d$var$isArrayBuffer,
    isBuffer: $aace3e920a0f1e4d$var$isBuffer,
    isFormData: $aace3e920a0f1e4d$var$isFormData,
    isArrayBufferView: $aace3e920a0f1e4d$var$isArrayBufferView,
    isString: $aace3e920a0f1e4d$var$isString,
    isNumber: $aace3e920a0f1e4d$var$isNumber,
    isBoolean: $aace3e920a0f1e4d$var$isBoolean,
    isObject: $aace3e920a0f1e4d$var$isObject,
    isPlainObject: $aace3e920a0f1e4d$var$isPlainObject,
    isUndefined: $aace3e920a0f1e4d$var$isUndefined,
    isDate: $aace3e920a0f1e4d$var$isDate,
    isFile: $aace3e920a0f1e4d$var$isFile,
    isBlob: $aace3e920a0f1e4d$var$isBlob,
    isRegExp: $aace3e920a0f1e4d$var$isRegExp,
    isFunction: $aace3e920a0f1e4d$var$isFunction,
    isStream: $aace3e920a0f1e4d$var$isStream,
    isURLSearchParams: $aace3e920a0f1e4d$var$isURLSearchParams,
    isTypedArray: $aace3e920a0f1e4d$var$isTypedArray,
    isFileList: $aace3e920a0f1e4d$var$isFileList,
    forEach: $aace3e920a0f1e4d$var$forEach,
    merge: $aace3e920a0f1e4d$var$merge,
    extend: $aace3e920a0f1e4d$var$extend,
    trim: $aace3e920a0f1e4d$var$trim,
    stripBOM: $aace3e920a0f1e4d$var$stripBOM,
    inherits: $aace3e920a0f1e4d$var$inherits,
    toFlatObject: $aace3e920a0f1e4d$var$toFlatObject,
    kindOf: $aace3e920a0f1e4d$var$kindOf,
    kindOfTest: $aace3e920a0f1e4d$var$kindOfTest,
    endsWith: $aace3e920a0f1e4d$var$endsWith,
    toArray: $aace3e920a0f1e4d$var$toArray,
    forEachEntry: $aace3e920a0f1e4d$var$forEachEntry,
    matchAll: $aace3e920a0f1e4d$var$matchAll,
    isHTMLForm: $aace3e920a0f1e4d$var$isHTMLForm,
    hasOwnProperty: $aace3e920a0f1e4d$var$hasOwnProperty,
    hasOwnProp: $aace3e920a0f1e4d$var$hasOwnProperty,
    reduceDescriptors: $aace3e920a0f1e4d$var$reduceDescriptors,
    freezeMethods: $aace3e920a0f1e4d$var$freezeMethods,
    toObjectSet: $aace3e920a0f1e4d$var$toObjectSet,
    toCamelCase: $aace3e920a0f1e4d$var$toCamelCase,
    noop: $aace3e920a0f1e4d$var$noop,
    toFiniteNumber: $aace3e920a0f1e4d$var$toFiniteNumber,
    findKey: $aace3e920a0f1e4d$var$findKey,
    global: $aace3e920a0f1e4d$var$_global,
    isContextDefined: $aace3e920a0f1e4d$var$isContextDefined,
    ALPHABET: $aace3e920a0f1e4d$var$ALPHABET,
    generateString: $aace3e920a0f1e4d$var$generateString,
    isSpecCompliantForm: $aace3e920a0f1e4d$var$isSpecCompliantForm,
    toJSONObject: $aace3e920a0f1e4d$var$toJSONObject,
    isAsyncFn: $aace3e920a0f1e4d$var$isAsyncFn,
    isThenable: $aace3e920a0f1e4d$var$isThenable
};







"use strict";
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $0139f1d30f4d6bd5$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = "AxiosError";
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    response && (this.response = response);
}
(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).inherits($0139f1d30f4d6bd5$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).toJSONObject(this.config),
            code: this.code,
            status: this.response && this.response.status ? this.response.status : null
        };
    }
});
const $0139f1d30f4d6bd5$var$prototype = $0139f1d30f4d6bd5$var$AxiosError.prototype;
const $0139f1d30f4d6bd5$var$descriptors = {};
[
    "ERR_BAD_OPTION_VALUE",
    "ERR_BAD_OPTION",
    "ECONNABORTED",
    "ETIMEDOUT",
    "ERR_NETWORK",
    "ERR_FR_TOO_MANY_REDIRECTS",
    "ERR_DEPRECATED",
    "ERR_BAD_RESPONSE",
    "ERR_BAD_REQUEST",
    "ERR_CANCELED",
    "ERR_NOT_SUPPORT",
    "ERR_INVALID_URL"
].forEach((code)=>{
    $0139f1d30f4d6bd5$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($0139f1d30f4d6bd5$var$AxiosError, $0139f1d30f4d6bd5$var$descriptors);
Object.defineProperty($0139f1d30f4d6bd5$var$prototype, "isAxiosError", {
    value: true
});
// eslint-disable-next-line func-names
$0139f1d30f4d6bd5$var$AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create($0139f1d30f4d6bd5$var$prototype);
    (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== "isAxiosError";
    });
    $0139f1d30f4d6bd5$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $0139f1d30f4d6bd5$export$2e2bcd8739ae039 = $0139f1d30f4d6bd5$var$AxiosError;


// eslint-disable-next-line strict
var $86ebf0c810395e29$export$2e2bcd8739ae039 = null;


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $0934e0939605d48c$export$a143d493d941bafc;
var $0934e0939605d48c$export$e4cf37d7f6fb9e0a;
var $0934e0939605d48c$export$f99ded8fe4b79145;
var $0934e0939605d48c$export$599f31c3813fae4d;
"use strict";
var $8a0a73e6b73fd0c4$export$a48f0734ac7c2329;
var $8a0a73e6b73fd0c4$export$d622b2ad8d90c771;
var $8a0a73e6b73fd0c4$export$6100ba28696e12de;
"use strict";
$8a0a73e6b73fd0c4$export$a48f0734ac7c2329 = $8a0a73e6b73fd0c4$var$byteLength;
$8a0a73e6b73fd0c4$export$d622b2ad8d90c771 = $8a0a73e6b73fd0c4$var$toByteArray;
$8a0a73e6b73fd0c4$export$6100ba28696e12de = $8a0a73e6b73fd0c4$var$fromByteArray;
var $8a0a73e6b73fd0c4$var$lookup = [];
var $8a0a73e6b73fd0c4$var$revLookup = [];
var $8a0a73e6b73fd0c4$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $8a0a73e6b73fd0c4$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $8a0a73e6b73fd0c4$var$i = 0, $8a0a73e6b73fd0c4$var$len = $8a0a73e6b73fd0c4$var$code.length; $8a0a73e6b73fd0c4$var$i < $8a0a73e6b73fd0c4$var$len; ++$8a0a73e6b73fd0c4$var$i){
    $8a0a73e6b73fd0c4$var$lookup[$8a0a73e6b73fd0c4$var$i] = $8a0a73e6b73fd0c4$var$code[$8a0a73e6b73fd0c4$var$i];
    $8a0a73e6b73fd0c4$var$revLookup[$8a0a73e6b73fd0c4$var$code.charCodeAt($8a0a73e6b73fd0c4$var$i)] = $8a0a73e6b73fd0c4$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$8a0a73e6b73fd0c4$var$revLookup["-".charCodeAt(0)] = 62;
$8a0a73e6b73fd0c4$var$revLookup["_".charCodeAt(0)] = 63;
function $8a0a73e6b73fd0c4$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $8a0a73e6b73fd0c4$var$byteLength(b64) {
    var lens = $8a0a73e6b73fd0c4$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $8a0a73e6b73fd0c4$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $8a0a73e6b73fd0c4$var$toByteArray(b64) {
    var tmp;
    var lens = $8a0a73e6b73fd0c4$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $8a0a73e6b73fd0c4$var$Arr($8a0a73e6b73fd0c4$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i)] << 18 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i)] << 2 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i)] << 10 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $8a0a73e6b73fd0c4$var$tripletToBase64(num) {
    return $8a0a73e6b73fd0c4$var$lookup[num >> 18 & 0x3F] + $8a0a73e6b73fd0c4$var$lookup[num >> 12 & 0x3F] + $8a0a73e6b73fd0c4$var$lookup[num >> 6 & 0x3F] + $8a0a73e6b73fd0c4$var$lookup[num & 0x3F];
}
function $8a0a73e6b73fd0c4$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($8a0a73e6b73fd0c4$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $8a0a73e6b73fd0c4$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($8a0a73e6b73fd0c4$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($8a0a73e6b73fd0c4$var$lookup[tmp >> 2] + $8a0a73e6b73fd0c4$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($8a0a73e6b73fd0c4$var$lookup[tmp >> 10] + $8a0a73e6b73fd0c4$var$lookup[tmp >> 4 & 0x3F] + $8a0a73e6b73fd0c4$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $998eb38f4d082829$export$aafa59e2e03f2942;
var $998eb38f4d082829$export$68d8715fc104d294;
$998eb38f4d082829$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$998eb38f4d082829$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


var $0934e0939605d48c$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$0934e0939605d48c$export$a143d493d941bafc = $0934e0939605d48c$var$Buffer;
$0934e0939605d48c$export$e4cf37d7f6fb9e0a = $0934e0939605d48c$var$SlowBuffer;
$0934e0939605d48c$export$f99ded8fe4b79145 = 50;
var $0934e0939605d48c$var$K_MAX_LENGTH = 0x7fffffff;
$0934e0939605d48c$export$599f31c3813fae4d = $0934e0939605d48c$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $0934e0939605d48c$var$Buffer.TYPED_ARRAY_SUPPORT = $0934e0939605d48c$var$typedArraySupport();
if (!$0934e0939605d48c$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $0934e0939605d48c$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($0934e0939605d48c$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$0934e0939605d48c$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($0934e0939605d48c$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$0934e0939605d48c$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $0934e0939605d48c$var$createBuffer(length) {
    if (length > $0934e0939605d48c$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $0934e0939605d48c$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $0934e0939605d48c$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $0934e0939605d48c$var$allocUnsafe(arg);
    }
    return $0934e0939605d48c$var$from(arg, encodingOrOffset, length);
}
$0934e0939605d48c$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $0934e0939605d48c$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $0934e0939605d48c$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $0934e0939605d48c$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($0934e0939605d48c$var$isInstance(value, ArrayBuffer) || value && $0934e0939605d48c$var$isInstance(value.buffer, ArrayBuffer)) return $0934e0939605d48c$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($0934e0939605d48c$var$isInstance(value, SharedArrayBuffer) || value && $0934e0939605d48c$var$isInstance(value.buffer, SharedArrayBuffer))) return $0934e0939605d48c$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $0934e0939605d48c$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $0934e0939605d48c$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $0934e0939605d48c$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $0934e0939605d48c$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $0934e0939605d48c$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($0934e0939605d48c$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($0934e0939605d48c$var$Buffer, Uint8Array);
function $0934e0939605d48c$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $0934e0939605d48c$var$alloc(size, fill, encoding) {
    $0934e0939605d48c$var$assertSize(size);
    if (size <= 0) return $0934e0939605d48c$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $0934e0939605d48c$var$createBuffer(size).fill(fill, encoding) : $0934e0939605d48c$var$createBuffer(size).fill(fill);
    return $0934e0939605d48c$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $0934e0939605d48c$var$Buffer.alloc = function(size, fill, encoding) {
    return $0934e0939605d48c$var$alloc(size, fill, encoding);
};
function $0934e0939605d48c$var$allocUnsafe(size) {
    $0934e0939605d48c$var$assertSize(size);
    return $0934e0939605d48c$var$createBuffer(size < 0 ? 0 : $0934e0939605d48c$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $0934e0939605d48c$var$Buffer.allocUnsafe = function(size) {
    return $0934e0939605d48c$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $0934e0939605d48c$var$Buffer.allocUnsafeSlow = function(size) {
    return $0934e0939605d48c$var$allocUnsafe(size);
};
function $0934e0939605d48c$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$0934e0939605d48c$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    var length = $0934e0939605d48c$var$byteLength(string, encoding) | 0;
    var buf = $0934e0939605d48c$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $0934e0939605d48c$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $0934e0939605d48c$var$checked(array.length) | 0;
    var buf = $0934e0939605d48c$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $0934e0939605d48c$var$fromArrayView(arrayView) {
    if ($0934e0939605d48c$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $0934e0939605d48c$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $0934e0939605d48c$var$fromArrayLike(arrayView);
}
function $0934e0939605d48c$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $0934e0939605d48c$var$Buffer.prototype);
    return buf;
}
function $0934e0939605d48c$var$fromObject(obj) {
    if ($0934e0939605d48c$var$Buffer.isBuffer(obj)) {
        var len = $0934e0939605d48c$var$checked(obj.length) | 0;
        var buf = $0934e0939605d48c$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $0934e0939605d48c$var$numberIsNaN(obj.length)) return $0934e0939605d48c$var$createBuffer(0);
        return $0934e0939605d48c$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $0934e0939605d48c$var$fromArrayLike(obj.data);
}
function $0934e0939605d48c$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $0934e0939605d48c$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $0934e0939605d48c$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $0934e0939605d48c$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $0934e0939605d48c$var$Buffer.alloc(+length);
}
$0934e0939605d48c$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $0934e0939605d48c$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$0934e0939605d48c$var$Buffer.compare = function compare(a, b) {
    if ($0934e0939605d48c$var$isInstance(a, Uint8Array)) a = $0934e0939605d48c$var$Buffer.from(a, a.offset, a.byteLength);
    if ($0934e0939605d48c$var$isInstance(b, Uint8Array)) b = $0934e0939605d48c$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$0934e0939605d48c$var$Buffer.isBuffer(a) || !$0934e0939605d48c$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$0934e0939605d48c$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$0934e0939605d48c$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $0934e0939605d48c$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $0934e0939605d48c$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($0934e0939605d48c$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $0934e0939605d48c$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$0934e0939605d48c$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $0934e0939605d48c$var$byteLength(string, encoding) {
    if ($0934e0939605d48c$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $0934e0939605d48c$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $0934e0939605d48c$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $0934e0939605d48c$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $0934e0939605d48c$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$0934e0939605d48c$var$Buffer.byteLength = $0934e0939605d48c$var$byteLength;
function $0934e0939605d48c$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $0934e0939605d48c$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $0934e0939605d48c$var$utf8Slice(this, start, end);
        case "ascii":
            return $0934e0939605d48c$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $0934e0939605d48c$var$latin1Slice(this, start, end);
        case "base64":
            return $0934e0939605d48c$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $0934e0939605d48c$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$0934e0939605d48c$var$Buffer.prototype._isBuffer = true;
function $0934e0939605d48c$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$0934e0939605d48c$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)$0934e0939605d48c$var$swap(this, i, i + 1);
    return this;
};
$0934e0939605d48c$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        $0934e0939605d48c$var$swap(this, i, i + 3);
        $0934e0939605d48c$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$0934e0939605d48c$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        $0934e0939605d48c$var$swap(this, i, i + 7);
        $0934e0939605d48c$var$swap(this, i + 1, i + 6);
        $0934e0939605d48c$var$swap(this, i + 2, i + 5);
        $0934e0939605d48c$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$0934e0939605d48c$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $0934e0939605d48c$var$utf8Slice(this, 0, length);
    return $0934e0939605d48c$var$slowToString.apply(this, arguments);
};
$0934e0939605d48c$var$Buffer.prototype.toLocaleString = $0934e0939605d48c$var$Buffer.prototype.toString;
$0934e0939605d48c$var$Buffer.prototype.equals = function equals(b) {
    if (!$0934e0939605d48c$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $0934e0939605d48c$var$Buffer.compare(this, b) === 0;
};
$0934e0939605d48c$var$Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = $0934e0939605d48c$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($0934e0939605d48c$var$customInspectSymbol) $0934e0939605d48c$var$Buffer.prototype[$0934e0939605d48c$var$customInspectSymbol] = $0934e0939605d48c$var$Buffer.prototype.inspect;
$0934e0939605d48c$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($0934e0939605d48c$var$isInstance(target, Uint8Array)) target = $0934e0939605d48c$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$0934e0939605d48c$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $0934e0939605d48c$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($0934e0939605d48c$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $0934e0939605d48c$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($0934e0939605d48c$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $0934e0939605d48c$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $0934e0939605d48c$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $0934e0939605d48c$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$0934e0939605d48c$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$0934e0939605d48c$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $0934e0939605d48c$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$0934e0939605d48c$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $0934e0939605d48c$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $0934e0939605d48c$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($0934e0939605d48c$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $0934e0939605d48c$var$utf8Write(buf, string, offset, length) {
    return $0934e0939605d48c$var$blitBuffer($0934e0939605d48c$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $0934e0939605d48c$var$asciiWrite(buf, string, offset, length) {
    return $0934e0939605d48c$var$blitBuffer($0934e0939605d48c$var$asciiToBytes(string), buf, offset, length);
}
function $0934e0939605d48c$var$base64Write(buf, string, offset, length) {
    return $0934e0939605d48c$var$blitBuffer($0934e0939605d48c$var$base64ToBytes(string), buf, offset, length);
}
function $0934e0939605d48c$var$ucs2Write(buf, string, offset, length) {
    return $0934e0939605d48c$var$blitBuffer($0934e0939605d48c$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$0934e0939605d48c$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $0934e0939605d48c$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $0934e0939605d48c$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $0934e0939605d48c$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $0934e0939605d48c$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $0934e0939605d48c$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$0934e0939605d48c$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $0934e0939605d48c$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $8a0a73e6b73fd0c4$export$6100ba28696e12de(buf);
    else return $8a0a73e6b73fd0c4$export$6100ba28696e12de(buf.slice(start, end));
}
function $0934e0939605d48c$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $0934e0939605d48c$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $0934e0939605d48c$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $0934e0939605d48c$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $0934e0939605d48c$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $0934e0939605d48c$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $0934e0939605d48c$var$asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $0934e0939605d48c$var$latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $0934e0939605d48c$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += $0934e0939605d48c$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $0934e0939605d48c$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$0934e0939605d48c$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $0934e0939605d48c$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $0934e0939605d48c$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$0934e0939605d48c$var$Buffer.prototype.readUintLE = $0934e0939605d48c$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$0934e0939605d48c$var$Buffer.prototype.readUintBE = $0934e0939605d48c$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$0934e0939605d48c$var$Buffer.prototype.readUint8 = $0934e0939605d48c$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$0934e0939605d48c$var$Buffer.prototype.readUint16LE = $0934e0939605d48c$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$0934e0939605d48c$var$Buffer.prototype.readUint16BE = $0934e0939605d48c$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$0934e0939605d48c$var$Buffer.prototype.readUint32LE = $0934e0939605d48c$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$0934e0939605d48c$var$Buffer.prototype.readUint32BE = $0934e0939605d48c$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$0934e0939605d48c$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$0934e0939605d48c$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$0934e0939605d48c$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$0934e0939605d48c$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$0934e0939605d48c$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$0934e0939605d48c$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$0934e0939605d48c$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$0934e0939605d48c$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return $998eb38f4d082829$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$0934e0939605d48c$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return $998eb38f4d082829$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$0934e0939605d48c$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 8, this.length);
    return $998eb38f4d082829$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$0934e0939605d48c$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 8, this.length);
    return $998eb38f4d082829$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $0934e0939605d48c$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$0934e0939605d48c$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$0934e0939605d48c$var$Buffer.prototype.writeUintLE = $0934e0939605d48c$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $0934e0939605d48c$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$0934e0939605d48c$var$Buffer.prototype.writeUintBE = $0934e0939605d48c$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $0934e0939605d48c$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint8 = $0934e0939605d48c$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint16LE = $0934e0939605d48c$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint16BE = $0934e0939605d48c$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint32LE = $0934e0939605d48c$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint32BE = $0934e0939605d48c$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$0934e0939605d48c$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $0934e0939605d48c$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$0934e0939605d48c$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $0934e0939605d48c$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $0934e0939605d48c$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $0934e0939605d48c$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $998eb38f4d082829$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$0934e0939605d48c$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $0934e0939605d48c$var$writeFloat(this, value, offset, true, noAssert);
};
$0934e0939605d48c$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $0934e0939605d48c$var$writeFloat(this, value, offset, false, noAssert);
};
function $0934e0939605d48c$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $998eb38f4d082829$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$0934e0939605d48c$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $0934e0939605d48c$var$writeDouble(this, value, offset, true, noAssert);
};
$0934e0939605d48c$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $0934e0939605d48c$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$0934e0939605d48c$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$0934e0939605d48c$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$0934e0939605d48c$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$0934e0939605d48c$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $0934e0939605d48c$var$Buffer.isBuffer(val) ? val : $0934e0939605d48c$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $0934e0939605d48c$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $0934e0939605d48c$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($0934e0939605d48c$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $0934e0939605d48c$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $0934e0939605d48c$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $0934e0939605d48c$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $0934e0939605d48c$var$base64ToBytes(str) {
    return $8a0a73e6b73fd0c4$export$d622b2ad8d90c771($0934e0939605d48c$var$base64clean(str));
}
function $0934e0939605d48c$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $0934e0939605d48c$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $0934e0939605d48c$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $0934e0939605d48c$var$hexSliceLookupTable = function() {
    var alphabet = "0123456789abcdef";
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();


var $fd07b9cb0132c1f6$require$Buffer = $0934e0939605d48c$export$a143d493d941bafc;
"use strict";
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $fd07b9cb0132c1f6$var$isVisitable(thing) {
    return (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $fd07b9cb0132c1f6$var$removeBrackets(key) {
    return (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).endsWith(key, "[]") ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $fd07b9cb0132c1f6$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $fd07b9cb0132c1f6$var$removeBrackets(token);
        return !dots && i ? "[" + token + "]" : token;
    }).join(dots ? "." : "");
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $fd07b9cb0132c1f6$var$isFlatArray(arr) {
    return (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(arr) && !arr.some($fd07b9cb0132c1f6$var$isVisitable);
}
const $fd07b9cb0132c1f6$var$predicates = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).toFlatObject((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $fd07b9cb0132c1f6$var$toFormData(obj, formData, options) {
    if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("target must be an object");
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $86ebf0c810395e29$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== "undefined" && Blob;
    const useBlob = _Blob && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError("visitor must be a function");
    function convertValue(value) {
        if (value === null) return "";
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if (!useBlob && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)("Blob is not supported. Use a Buffer instead.");
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isTypedArray(value)) return useBlob && typeof Blob === "function" ? new Blob([
            value
        ]) : $fd07b9cb0132c1f6$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === "object") {
            if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).endsWith(key, "{}")) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(value) && $fd07b9cb0132c1f6$var$isFlatArray(value) || ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFileList(value) || (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).endsWith(key, "[]")) && (arr = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $fd07b9cb0132c1f6$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $fd07b9cb0132c1f6$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + "[]", convertValue(el));
                });
                return false;
            }
        }
        if ($fd07b9cb0132c1f6$var$isVisitable(value)) return true;
        formData.append($fd07b9cb0132c1f6$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($fd07b9cb0132c1f6$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $fd07b9cb0132c1f6$var$isVisitable
    });
    function build(value, path) {
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error("Circular reference detected in " + path.join("."));
        stack.push(value);
        (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("data must be an object");
    build(obj);
    return formData;
}
var $fd07b9cb0132c1f6$export$2e2bcd8739ae039 = $fd07b9cb0132c1f6$var$toFormData;


"use strict";
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $344cf8e4292137b6$var$encode(str) {
    const charMap = {
        "!": "%21",
        "'": "%27",
        "(": "%28",
        ")": "%29",
        "~": "%7E",
        "%20": "+",
        "%00": "\x00"
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $344cf8e4292137b6$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $fd07b9cb0132c1f6$export$2e2bcd8739ae039)(params, this, options);
}
const $344cf8e4292137b6$var$prototype = $344cf8e4292137b6$var$AxiosURLSearchParams.prototype;
$344cf8e4292137b6$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$344cf8e4292137b6$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $344cf8e4292137b6$var$encode);
    } : $344cf8e4292137b6$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + "=" + _encode(pair[1]);
    }, "").join("&");
};
var $344cf8e4292137b6$export$2e2bcd8739ae039 = $344cf8e4292137b6$var$AxiosURLSearchParams;


"use strict";
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $db2f05ec923f2ee7$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function $db2f05ec923f2ee7$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || $db2f05ec923f2ee7$var$encode;
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $344cf8e4292137b6$export$2e2bcd8739ae039)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
}



"use strict";
class $01c17f80085c95b1$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $01c17f80085c95b1$export$2e2bcd8739ae039 = $01c17f80085c95b1$var$InterceptorManager;





"use strict";
var $3075bac9f30e7782$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};






"use strict";
var $a85e5bed82430d61$export$2e2bcd8739ae039 = typeof URLSearchParams !== "undefined" ? URLSearchParams : (0, $344cf8e4292137b6$export$2e2bcd8739ae039);


"use strict";
var $46b12d255f217052$export$2e2bcd8739ae039 = typeof FormData !== "undefined" ? FormData : null;


"use strict";
var $2e4211376cea43e6$export$2e2bcd8739ae039 = typeof Blob !== "undefined" ? Blob : null;


var $fb24c6d0b2a74508$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $a85e5bed82430d61$export$2e2bcd8739ae039,
        FormData: $46b12d255f217052$export$2e2bcd8739ae039,
        Blob: $2e4211376cea43e6$export$2e2bcd8739ae039
    },
    protocols: [
        "http",
        "https",
        "file",
        "blob",
        "url",
        "data"
    ]
};


var $232de52881daaba8$exports = {};

$parcel$export($232de52881daaba8$exports, "hasBrowserEnv", () => $232de52881daaba8$export$c4996c4b7b93b0bf);
$parcel$export($232de52881daaba8$exports, "hasStandardBrowserEnv", () => $232de52881daaba8$export$c0bcc9250309d66);
$parcel$export($232de52881daaba8$exports, "hasStandardBrowserWebWorkerEnv", () => $232de52881daaba8$export$c81692cf5af97dac);
const $232de52881daaba8$export$c4996c4b7b93b0bf = typeof window !== "undefined" && typeof document !== "undefined";
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $232de52881daaba8$export$c0bcc9250309d66 = ((product)=>{
    return $232de52881daaba8$export$c4996c4b7b93b0bf && [
        "ReactNative",
        "NativeScript",
        "NS"
    ].indexOf(product) < 0;
})(typeof navigator !== "undefined" && navigator.product);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $232de52881daaba8$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== "undefined" && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === "function";
})();


var $852831b4a152a7ad$export$2e2bcd8739ae039 = {
    ...$232de52881daaba8$exports,
    ...(0, $fb24c6d0b2a74508$export$2e2bcd8739ae039)
};


"use strict";
function $aa000567d8bb5ae2$export$2e2bcd8739ae039(data, options) {
    return (0, $fd07b9cb0132c1f6$export$2e2bcd8739ae039)(data, new (0, $852831b4a152a7ad$export$2e2bcd8739ae039).classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ((0, $852831b4a152a7ad$export$2e2bcd8739ae039).isNode && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString("base64"));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}




"use strict";
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $cb8fe7f388dc4432$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === "[]" ? "" : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $cb8fe7f388dc4432$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $cb8fe7f388dc4432$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === "__proto__") return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $cb8fe7f388dc4432$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFormData(formData) && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($cb8fe7f388dc4432$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $cb8fe7f388dc4432$export$2e2bcd8739ae039 = $cb8fe7f388dc4432$var$formDataToJSON;


"use strict";
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $e30871f78dcd7f19$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $e30871f78dcd7f19$var$defaults = {
    transitional: (0, $3075bac9f30e7782$export$2e2bcd8739ae039),
    adapter: [
        "xhr",
        "http"
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || "";
            const hasJSONContentType = contentType.indexOf("application/json") > -1;
            const isObjectPayload = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) {
                if (!hasJSONContentType) return data;
                return hasJSONContentType ? JSON.stringify((0, $cb8fe7f388dc4432$export$2e2bcd8739ae039)(data)) : data;
            }
            if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isBuffer(data) || (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isStream(data) || (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFile(data) || (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isBlob(data)) return data;
            if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType("application/x-www-form-urlencoded;charset=utf-8", false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf("application/x-www-form-urlencoded") > -1) return (0, $aa000567d8bb5ae2$export$2e2bcd8739ae039)(data, this.formSerializer).toString();
                if ((isFileList = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf("multipart/form-data") > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $fd07b9cb0132c1f6$export$2e2bcd8739ae039)(isFileList ? {
                        "files[]": data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType("application/json", false);
                return $e30871f78dcd7f19$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $e30871f78dcd7f19$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === "json";
            if (data && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === "SyntaxError") throw (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).from(e, (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $852831b4a152a7ad$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $852831b4a152a7ad$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            "Accept": "application/json, text/plain, */*",
            "Content-Type": undefined
        }
    }
};
(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head",
    "post",
    "put",
    "patch"
], (method)=>{
    $e30871f78dcd7f19$var$defaults.headers[method] = {};
});
var $e30871f78dcd7f19$export$2e2bcd8739ae039 = $e30871f78dcd7f19$var$defaults;




"use strict";
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $36eacf0f5ae88424$var$ignoreDuplicateOf = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).toObjectSet([
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $36eacf0f5ae88424$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split("\n").forEach(function parser(line) {
        i = line.indexOf(":");
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $36eacf0f5ae88424$var$ignoreDuplicateOf[key]) return;
        if (key === "set-cookie") {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
    });
    return parsed;
};


"use strict";
const $54e5234108b8e954$var$$internals = Symbol("internals");
function $54e5234108b8e954$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $54e5234108b8e954$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(value) ? value.map($54e5234108b8e954$var$normalizeValue) : String(value);
}
function $54e5234108b8e954$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $54e5234108b8e954$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $54e5234108b8e954$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $54e5234108b8e954$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $54e5234108b8e954$var$buildAccessors(obj, header) {
    const accessorName = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).toCamelCase(" " + header);
    [
        "get",
        "set",
        "has"
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $54e5234108b8e954$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $54e5234108b8e954$var$normalizeHeader(_header);
            if (!lHeader) throw new Error("header name must be a non-empty string");
            const key = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $54e5234108b8e954$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$54e5234108b8e954$var$isValidHeaderName(header)) setHeaders((0, $36eacf0f5ae88424$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $54e5234108b8e954$var$normalizeHeader(header);
        if (header) {
            const key = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $54e5234108b8e954$var$parseTokens(value);
                if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError("parser must be boolean|regexp|function");
            }
        }
    }
    has(header, matcher) {
        header = $54e5234108b8e954$var$normalizeHeader(header);
        if (header) {
            const key = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $54e5234108b8e954$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $54e5234108b8e954$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $54e5234108b8e954$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $54e5234108b8e954$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $54e5234108b8e954$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $54e5234108b8e954$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $54e5234108b8e954$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(value) ? value.join(", ") : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ": " + value).join("\n");
    }
    get [Symbol.toStringTag]() {
        return "AxiosHeaders";
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$54e5234108b8e954$var$$internals] = this[$54e5234108b8e954$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $54e5234108b8e954$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $54e5234108b8e954$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$54e5234108b8e954$var$AxiosHeaders.accessor([
    "Content-Type",
    "Content-Length",
    "Accept",
    "Accept-Encoding",
    "User-Agent",
    "Authorization"
]);
// reserved names hotfix
(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).reduceDescriptors($54e5234108b8e954$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).freezeMethods($54e5234108b8e954$var$AxiosHeaders);
var $54e5234108b8e954$export$2e2bcd8739ae039 = $54e5234108b8e954$var$AxiosHeaders;


"use strict";
function $ec027d10dfede142$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $e30871f78dcd7f19$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $54e5234108b8e954$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


"use strict";
function $fbc9c01c5c3dc518$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}





"use strict";
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $63b8b72909769bf2$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).call(this, message == null ? "canceled" : message, (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
    this.name = "CanceledError";
}
(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).inherits($63b8b72909769bf2$var$CanceledError, (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039), {
    __CANCEL__: true
});
var $63b8b72909769bf2$export$2e2bcd8739ae039 = $63b8b72909769bf2$var$CanceledError;







"use strict";
function $c0e22576f74b8071$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)("Request failed with status code " + response.status, [
        (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_BAD_REQUEST,
        (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}




var $4d3cf801f7fd4dc6$export$2e2bcd8739ae039 = (0, $852831b4a152a7ad$export$2e2bcd8739ae039).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write (name, value, expires, path, domain, secure) {
        const cookie = [
            name + "=" + encodeURIComponent(value)
        ];
        (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isNumber(expires) && cookie.push("expires=" + new Date(expires).toGMTString());
        (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isString(path) && cookie.push("path=" + path);
        (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isString(domain) && cookie.push("domain=" + domain);
        secure === true && cookie.push("secure");
        document.cookie = cookie.join("; ");
    },
    read (name) {
        const match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
        return match ? decodeURIComponent(match[3]) : null;
    },
    remove (name) {
        this.write(name, "", Date.now() - 86400000);
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write () {},
    read () {
        return null;
    },
    remove () {}
};



"use strict";
function $05bf269bfca011f3$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


"use strict";
function $7c49e720f6231ba2$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
}


"use strict";
function $8ed3292b1f9dccb5$export$2e2bcd8739ae039(baseURL, requestedURL) {
    if (baseURL && !(0, $05bf269bfca011f3$export$2e2bcd8739ae039)(requestedURL)) return (0, $7c49e720f6231ba2$export$2e2bcd8739ae039)(baseURL, requestedURL);
    return requestedURL;
}




"use strict";
var $3a08e3bf7b3045fa$export$2e2bcd8739ae039 = (0, $852831b4a152a7ad$export$2e2bcd8739ae039).hasStandardBrowserEnv ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    const msie = /(msie|trident)/i.test(navigator.userAgent);
    const urlParsingNode = document.createElement("a");
    let originURL;
    /**
    * Parse a URL to discover its components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        let href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        const parsed = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();





"use strict";
function $9cab09d0d089fc0e$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || "";
}




"use strict";
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $48a8aeed25ee768a$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $48a8aeed25ee768a$export$2e2bcd8739ae039 = $48a8aeed25ee768a$var$speedometer;


"use strict";
function $61abd1574bd1dd32$var$progressEventReducer(listener, isDownloadStream) {
    let bytesNotified = 0;
    const _speedometer = (0, $48a8aeed25ee768a$export$2e2bcd8739ae039)(50, 250);
    return (e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e
        };
        data[isDownloadStream ? "download" : "upload"] = true;
        listener(data);
    };
}
const $61abd1574bd1dd32$var$isXHRAdapterSupported = typeof XMLHttpRequest !== "undefined";
var $61abd1574bd1dd32$export$2e2bcd8739ae039 = $61abd1574bd1dd32$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        let requestData = config.data;
        const requestHeaders = (0, $54e5234108b8e954$export$2e2bcd8739ae039).from(config.headers).normalize();
        let { responseType: responseType, withXSRFToken: withXSRFToken } = config;
        let onCanceled;
        function done() {
            if (config.cancelToken) config.cancelToken.unsubscribe(onCanceled);
            if (config.signal) config.signal.removeEventListener("abort", onCanceled);
        }
        let contentType;
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFormData(requestData)) {
            if ((0, $852831b4a152a7ad$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $852831b4a152a7ad$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv) requestHeaders.setContentType(false); // Let the browser set it
            else if ((contentType = requestHeaders.getContentType()) !== false) {
                // fix semicolon duplication issue for ReactNative FormData implementation
                const [type, ...tokens] = contentType ? contentType.split(";").map((token)=>token.trim()).filter(Boolean) : [];
                requestHeaders.setContentType([
                    type || "multipart/form-data",
                    ...tokens
                ].join("; "));
            }
        }
        let request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            const username = config.auth.username || "";
            const password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
            requestHeaders.set("Authorization", "Basic " + btoa(username + ":" + password));
        }
        const fullPath = (0, $8ed3292b1f9dccb5$export$2e2bcd8739ae039)(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), (0, $db2f05ec923f2ee7$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $54e5234108b8e954$export$2e2bcd8739ae039).from("getAllResponseHeaders" in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $c0e22576f74b8071$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)("Request aborted", (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)("Network Error", (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = config.timeout ? "timeout of " + config.timeout + "ms exceeded" : "timeout exceeded";
            const transitional = config.transitional || (0, $3075bac9f30e7782$export$2e2bcd8739ae039);
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject(new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ETIMEDOUT : (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ((0, $852831b4a152a7ad$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
            withXSRFToken && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(config));
            if (withXSRFToken || withXSRFToken !== false && (0, $3a08e3bf7b3045fa$export$2e2bcd8739ae039)(fullPath)) {
                // Add xsrf header
                const xsrfValue = config.xsrfHeaderName && config.xsrfCookieName && (0, $4d3cf801f7fd4dc6$export$2e2bcd8739ae039).read(config.xsrfCookieName);
                if (xsrfValue) requestHeaders.set(config.xsrfHeaderName, xsrfValue);
            }
        }
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ("setRequestHeader" in request) (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === "function") request.addEventListener("progress", $61abd1574bd1dd32$var$progressEventReducer(config.onDownloadProgress, true));
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", $61abd1574bd1dd32$var$progressEventReducer(config.onUploadProgress));
        if (config.cancelToken || config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $63b8b72909769bf2$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            config.cancelToken && config.cancelToken.subscribe(onCanceled);
            if (config.signal) config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
        }
        const protocol = (0, $9cab09d0d089fc0e$export$2e2bcd8739ae039)(fullPath);
        if (protocol && (0, $852831b4a152a7ad$export$2e2bcd8739ae039).protocols.indexOf(protocol) === -1) {
            reject(new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)("Unsupported protocol " + protocol + ":", (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};



const $d570c100e0cb7a05$var$knownAdapters = {
    http: (0, $86ebf0c810395e29$export$2e2bcd8739ae039),
    xhr: (0, $61abd1574bd1dd32$export$2e2bcd8739ae039)
};
(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach($d570c100e0cb7a05$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, "name", {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, "adapterName", {
            value: value
        });
    }
});
const $d570c100e0cb7a05$var$renderReason = (reason)=>`- ${reason}`;
const $d570c100e0cb7a05$var$isResolvedHandle = (adapter)=>(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
var $d570c100e0cb7a05$export$2e2bcd8739ae039 = {
    getAdapter: (adapters)=>{
        adapters = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length: length } = adapters;
        let nameOrAdapter;
        let adapter;
        const rejectedReasons = {};
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            let id;
            adapter = nameOrAdapter;
            if (!$d570c100e0cb7a05$var$isResolvedHandle(nameOrAdapter)) {
                adapter = $d570c100e0cb7a05$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) throw new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)(`Unknown adapter '${id}'`);
            }
            if (adapter) break;
            rejectedReasons[id || "#" + i] = adapter;
        }
        if (!adapter) {
            const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? "is not supported by the environment" : "is not available in the build"));
            let s = length ? reasons.length > 1 ? "since :\n" + reasons.map($d570c100e0cb7a05$var$renderReason).join("\n") : " " + $d570c100e0cb7a05$var$renderReason(reasons[0]) : "as no adapter specified";
            throw new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)(`There is no suitable adapter to dispatch the request ` + s, "ERR_NOT_SUPPORT");
        }
        return adapter;
    },
    adapters: $d570c100e0cb7a05$var$knownAdapters
};


"use strict";
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $96666136aaccd2e5$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $63b8b72909769bf2$export$2e2bcd8739ae039)(null, config);
}
function $96666136aaccd2e5$export$2e2bcd8739ae039(config) {
    $96666136aaccd2e5$var$throwIfCancellationRequested(config);
    config.headers = (0, $54e5234108b8e954$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $ec027d10dfede142$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        "post",
        "put",
        "patch"
    ].indexOf(config.method) !== -1) config.headers.setContentType("application/x-www-form-urlencoded", false);
    const adapter = (0, $d570c100e0cb7a05$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $e30871f78dcd7f19$export$2e2bcd8739ae039).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        $96666136aaccd2e5$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $ec027d10dfede142$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        response.headers = (0, $54e5234108b8e954$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $fbc9c01c5c3dc518$export$2e2bcd8739ae039)(reason)) {
            $96666136aaccd2e5$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $ec027d10dfede142$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $54e5234108b8e954$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}




"use strict";
const $20ede3a7e8b675d4$var$headersToObject = (thing)=>thing instanceof (0, $54e5234108b8e954$export$2e2bcd8739ae039) ? thing.toJSON() : thing;
function $20ede3a7e8b675d4$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, caseless) {
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isPlainObject(target) && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, caseless) {
        if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, caseless);
        else if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b)=>mergeDeepProperties($20ede3a7e8b675d4$var$headersToObject(a), $20ede3a7e8b675d4$var$headersToObject(b), true)
    };
    (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}



const $4c74d331112ba968$export$a4ad2735b021c132 = "1.6.5";



"use strict";
const $63efb8494987aa98$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach((type, i)=>{
    $63efb8494987aa98$var$validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
const $63efb8494987aa98$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $63efb8494987aa98$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return "[Axios v" + (0, $4c74d331112ba968$export$a4ad2735b021c132) + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)(formatMessage(opt, " has been removed" + (version ? " in " + version : "")), (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$63efb8494987aa98$var$deprecatedWarnings[opt]) {
            $63efb8494987aa98$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $63efb8494987aa98$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)("options must be an object", (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)("option " + opt + " must be " + result, (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)("Unknown option " + opt, (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $63efb8494987aa98$export$2e2bcd8739ae039 = {
    assertOptions: $63efb8494987aa98$var$assertOptions,
    validators: $63efb8494987aa98$var$validators
};



"use strict";
const $cd0b8e3cbef64068$var$validators = (0, $63efb8494987aa98$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $cd0b8e3cbef64068$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig;
        this.interceptors = {
            request: new (0, $01c17f80085c95b1$export$2e2bcd8739ae039)(),
            response: new (0, $01c17f80085c95b1$export$2e2bcd8739ae039)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === "string") {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $20ede3a7e8b675d4$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $63efb8494987aa98$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $cd0b8e3cbef64068$var$validators.transitional($cd0b8e3cbef64068$var$validators.boolean),
            forcedJSONParsing: $cd0b8e3cbef64068$var$validators.transitional($cd0b8e3cbef64068$var$validators.boolean),
            clarifyTimeoutError: $cd0b8e3cbef64068$var$validators.transitional($cd0b8e3cbef64068$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $63efb8494987aa98$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $cd0b8e3cbef64068$var$validators.function,
                serialize: $cd0b8e3cbef64068$var$validators.function
            }, true);
        }
        // Set config.method
        config.method = (config.method || this.defaults.method || "get").toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach([
            "delete",
            "get",
            "head",
            "post",
            "put",
            "patch",
            "common"
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $54e5234108b8e954$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $96666136aaccd2e5$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift.apply(chain, requestInterceptorChain);
            chain.push.apply(chain, responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        i = 0;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $96666136aaccd2e5$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $20ede3a7e8b675d4$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $8ed3292b1f9dccb5$export$2e2bcd8739ae039)(config.baseURL, config.url);
        return (0, $db2f05ec923f2ee7$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $cd0b8e3cbef64068$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $20ede3a7e8b675d4$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $20ede3a7e8b675d4$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    "Content-Type": "multipart/form-data"
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $cd0b8e3cbef64068$var$Axios.prototype[method] = generateHTTPMethod();
    $cd0b8e3cbef64068$var$Axios.prototype[method + "Form"] = generateHTTPMethod(true);
});
var $cd0b8e3cbef64068$export$2e2bcd8739ae039 = $cd0b8e3cbef64068$var$Axios;







"use strict";
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $3218dd97b5460664$var$CancelToken {
    constructor(executor){
        if (typeof executor !== "function") throw new TypeError("executor must be a function.");
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $63b8b72909769bf2$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $3218dd97b5460664$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $3218dd97b5460664$export$2e2bcd8739ae039 = $3218dd97b5460664$var$CancelToken;






"use strict";
function $7874d702b64e6994$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



"use strict";
function $16f479813f4fb9c8$export$2e2bcd8739ae039(payload) {
    return (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $edd7ef3f6e3b67e5$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($edd7ef3f6e3b67e5$var$HttpStatusCode).forEach(([key, value])=>{
    $edd7ef3f6e3b67e5$var$HttpStatusCode[value] = key;
});
var $edd7ef3f6e3b67e5$export$2e2bcd8739ae039 = $edd7ef3f6e3b67e5$var$HttpStatusCode;


"use strict";
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $5d7526a7a1e5b3fb$var$createInstance(defaultConfig) {
    const context = new (0, $cd0b8e3cbef64068$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $93b0f01b05e2607a$export$2e2bcd8739ae039)((0, $cd0b8e3cbef64068$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).extend(instance, (0, $cd0b8e3cbef64068$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $5d7526a7a1e5b3fb$var$createInstance((0, $20ede3a7e8b675d4$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $5d7526a7a1e5b3fb$var$axios = $5d7526a7a1e5b3fb$var$createInstance((0, $e30871f78dcd7f19$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$5d7526a7a1e5b3fb$var$axios.Axios = (0, $cd0b8e3cbef64068$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$5d7526a7a1e5b3fb$var$axios.CanceledError = (0, $63b8b72909769bf2$export$2e2bcd8739ae039);
$5d7526a7a1e5b3fb$var$axios.CancelToken = (0, $3218dd97b5460664$export$2e2bcd8739ae039);
$5d7526a7a1e5b3fb$var$axios.isCancel = (0, $fbc9c01c5c3dc518$export$2e2bcd8739ae039);
$5d7526a7a1e5b3fb$var$axios.VERSION = (0, $4c74d331112ba968$export$a4ad2735b021c132);
$5d7526a7a1e5b3fb$var$axios.toFormData = (0, $fd07b9cb0132c1f6$export$2e2bcd8739ae039);
// Expose AxiosError class
$5d7526a7a1e5b3fb$var$axios.AxiosError = (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$5d7526a7a1e5b3fb$var$axios.Cancel = $5d7526a7a1e5b3fb$var$axios.CanceledError;
// Expose all/spread
$5d7526a7a1e5b3fb$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$5d7526a7a1e5b3fb$var$axios.spread = (0, $7874d702b64e6994$export$2e2bcd8739ae039);
// Expose isAxiosError
$5d7526a7a1e5b3fb$var$axios.isAxiosError = (0, $16f479813f4fb9c8$export$2e2bcd8739ae039);
// Expose mergeConfig
$5d7526a7a1e5b3fb$var$axios.mergeConfig = (0, $20ede3a7e8b675d4$export$2e2bcd8739ae039);
$5d7526a7a1e5b3fb$var$axios.AxiosHeaders = (0, $54e5234108b8e954$export$2e2bcd8739ae039);
$5d7526a7a1e5b3fb$var$axios.formToJSON = (thing)=>(0, $cb8fe7f388dc4432$export$2e2bcd8739ae039)((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$5d7526a7a1e5b3fb$var$axios.getAdapter = (0, $d570c100e0cb7a05$export$2e2bcd8739ae039).getAdapter;
$5d7526a7a1e5b3fb$var$axios.HttpStatusCode = (0, $edd7ef3f6e3b67e5$export$2e2bcd8739ae039);
$5d7526a7a1e5b3fb$var$axios.default = $5d7526a7a1e5b3fb$var$axios;
var // this module should only have a default export
$5d7526a7a1e5b3fb$export$2e2bcd8739ae039 = $5d7526a7a1e5b3fb$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $125d1ceb57662f9a$export$1c00760e9e5a4e95, AxiosError: $125d1ceb57662f9a$export$c1fbed17c2f6a328, CanceledError: $125d1ceb57662f9a$export$1ab0c6b20d94fa14, isCancel: $125d1ceb57662f9a$export$3b22524397b493c6, CancelToken: $125d1ceb57662f9a$export$fd08e3cb425f0d61, VERSION: $125d1ceb57662f9a$export$a4ad2735b021c132, all: $125d1ceb57662f9a$export$84bf76cd7afc7469, Cancel: $125d1ceb57662f9a$export$848c9b7ead0df967, isAxiosError: $125d1ceb57662f9a$export$fbafdbe06a5b5a9a, spread: $125d1ceb57662f9a$export$3ae0fd4797ed47c8, toFormData: $125d1ceb57662f9a$export$10ae0d317ea97f8b, AxiosHeaders: $125d1ceb57662f9a$export$4e7d6ff0f3e6520, HttpStatusCode: $125d1ceb57662f9a$export$a972f69c851492b3, formToJSON: $125d1ceb57662f9a$export$86d7c59254d6a2c9, getAdapter: $125d1ceb57662f9a$export$17ddc20a97d669e2, mergeConfig: $125d1ceb57662f9a$export$7ec1ebcfa9d8bd6a } = (0, $5d7526a7a1e5b3fb$export$2e2bcd8739ae039);


Shopify.functions.getCart = async function getCart() {
    try {
        const response = await (0, $5d7526a7a1e5b3fb$export$2e2bcd8739ae039).get("/cart.js");
        const cart = response.data;
        return cart;
    } catch (error) {
        console.error(error);
    }
};



Shopify.functions.removeItem = async function removeItem(lineItemKey, additionalData) {
    try {
        const data = {
            id: lineItemKey,
            quantity: 0,
            ...additionalData
        };
        const config = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        const response = await (0, $5d7526a7a1e5b3fb$export$2e2bcd8739ae039).post(theme.routes.cart_change_url, data, config);
        const cart = response.data;
        return cart;
    } catch (error) {
        console.error("Removing item error: ", error);
    }
};




function $9fa27e32840728c9$var$toggleClass(element, className, addClass) {
    if (addClass) element.classList.add(className);
    else element.classList.remove(className);
}
function $9fa27e32840728c9$var$removeSelectedBundleClass(className) {
    const selectedClass = document.querySelector(className);
    if (selectedClass) selectedClass.classList.remove("selected-bundle");
}
document.addEventListener("DOMContentLoaded", ()=>{
    const bundleButtons = document.querySelectorAll(".bundle-button");
    const productBundleWrapper = document.querySelectorAll(".product-bundle-wrapper");
    if (productBundleWrapper.length) {
        // Display first bundle by default
        const firstBundle = productBundleWrapper[0];
        $9fa27e32840728c9$var$toggleClass(firstBundle, "show-bundle", true);
    }
    bundleButtons.forEach((btn)=>{
        const buttonTarget = btn.dataset.target;
        btn.addEventListener("click", (e)=>{
            // Remove "selected-bundle" class
            $9fa27e32840728c9$var$removeSelectedBundleClass(".bundle-button.selected-bundle");
            // Add "selected-bundle" class to the clicked button
            $9fa27e32840728c9$var$toggleClass(btn, "selected-bundle", true);
            // Iterate through bundle wrapper: Subscriptions and One Time Purchase (otp)
            productBundleWrapper.forEach((bundleWrapper)=>{
                const bundleTarget = bundleWrapper.dataset.target;
                // Compare if data-target is the same for button and bundle-wrapper
                // If so, add class "show-bundle", else remove this class
                $9fa27e32840728c9$var$toggleClass(bundleWrapper, "show-bundle", buttonTarget === bundleTarget);
            });
        });
    });
    const bundleItems = document.querySelectorAll(".bundle-item");
    const sellingPlanInput = document.getElementById("product-form-selling-plan");
    const quantitySelector = document.getElementById("quantity-selector");
    const quantityInput = quantitySelector?.querySelector(".qty");
    if (bundleItems.length) {
        // Select first item by default
        const firstItem = bundleItems[0];
        $9fa27e32840728c9$var$toggleClass(firstItem, "selected-bundle", true);
        // On load: Collect value from first item and set it to Quantity input
        // Quantity input is the one that handles number of values added to the Cart
        if (quantityInput) quantityInput.value = firstItem.dataset.quantity ?? "0";
        // Do the same for Selling plan (subscription)
        sellingPlanInput.value = firstItem.dataset.planId ?? "0";
    }
    if (!sellingPlanInput || !quantitySelector || !quantityInput) return;
    bundleItems.forEach((item)=>{
        item.addEventListener("click", ()=>{
            // First remove class from all the items
            $9fa27e32840728c9$var$removeSelectedBundleClass(".bundle-item.selected-bundle");
            // Then add class to the clicked bundleItem
            $9fa27e32840728c9$var$toggleClass(item, "selected-bundle", true);
            // Get the plan id for subscription
            const planID = item.dataset.planId;
            sellingPlanInput.value = planID;
            // Set bundle quantity to quantity-selector input
            quantityInput.value = item.dataset.quantity ?? "0";
        });
    });
});


parcelRequire("3fmZL");
if (!customElements.get("c-collapse")) {
    class Collapse extends HTMLElement {
        constructor(){
            super();
            this.el = this.querySelector("details");
            if (!this.el) return;
            this.setupEventListeners();
        }
        setupEventListeners() {
            this.el.addEventListener("mouseenter", this.open.bind(this));
            this.el.addEventListener("mouseleave", this.close.bind(this));
            this.el.addEventListener("focusout", this.onFocusOut.bind(this));
        }
        onFocusOut() {
            setTimeout(()=>{
                if (!this.contains(document.activeElement)) this.close();
            });
        }
        open() {
            this.el.setAttribute("open", "");
        }
        close() {
            this.el.removeAttribute("open");
        }
    }
    customElements.define("c-collapse", Collapse);
}


// Add an event listener to the checkbox
document.body.addEventListener("change", function(event) {
    const wrapper = document.querySelector(".cart-uspell-wrapper");
    if (!wrapper) return;
    function addGiftBoxToCart(variantId) {
        wrapper.querySelector(`[data-product-id="${variantId}"]`)?.click();
    }
    function removeGiftBoxToCart(variantId) {
        document.querySelector(`.cart-drawer .product-cart-items .product-cart-item-info [data-variant-id="${variantId}"]`)?.click();
    }
    // Get the checkbox element
    const checkbox = wrapper.querySelector("#cartDrawerGiftBox");
    const variantId = checkbox.dataset.variantId;
    if (event.target && event.target.id === "cartDrawerGiftBox") {
        const checkbox = event.target;
        if (checkbox.checked) addGiftBoxToCart(variantId);
        else removeGiftBoxToCart(variantId);
    }
});


window.addEventListener("klaviyoForms", async function(event) {
    const triggerCampaignData = window.theme.triggerCampaign;
    if (!triggerCampaignData) return;
    const { id: campaignId, trigger: triggerCampaign, klaviyoFormId: formId } = triggerCampaignData;
    if (!campaignId || !triggerCampaign || !formId || triggerCampaign === "false") return;
    if (event.detail.type === "submit" && event.detail.formId === formId) {
        const klaviyoFormId = event.detail.formId;
        if (klaviyoFormId !== formId) return;
        const email = event.detail.metaData.$email;
        const BASE_URL = "https://bloyal-app-production-4451.up.railway.app";
        $b42dcaa7686cef7e$var$ensureStatusModal();
        $b42dcaa7686cef7e$var$openStatusModal(triggerCampaignData?.translations?.processing_title, triggerCampaignData?.translations?.processing_message, "loading");
        const requestUrl = `${BASE_URL}/customers/add-to-store-credit-from-link?email=${encodeURIComponent(email)}&campaign=${campaignId}&store=${window.theme.settings.store_name}`;
        for(let i = 0; i < 10; i++){
            const responseStatus = await $b42dcaa7686cef7e$var$addStoreCredit(requestUrl);
            if (responseStatus) {
                wasStoreCreditAdded = true;
                break;
            } else await new Promise((resolve)=>setTimeout(resolve, 4000));
        }
        if (wasStoreCreditAdded) $b42dcaa7686cef7e$var$updateStatusModal(triggerCampaignData?.translations?.success_title, triggerCampaignData?.translations?.success_message, "success");
        else $b42dcaa7686cef7e$var$updateStatusModal(triggerCampaignData?.translations?.error_title, triggerCampaignData?.translations?.error_message, "error");
    }
});
async function $b42dcaa7686cef7e$var$addStoreCredit(requestUrl) {
    try {
        const response = await fetch(requestUrl, {
            method: "GET",
            headers: {
                "Content-Type": "application/json"
            }
        });
        if (response.ok) {
            const data = await response.json();
            const urlRedirection = data.redirectURL;
            if (!urlRedirection || urlRedirection === null) return false;
            console.log("API call successful", data);
            return true;
        } else {
            console.warn(`HTTP error! Status: ${response.status}`);
            return false;
        }
    } catch (error) {
        console.error("API call failed:", error);
        return false;
    }
}
function $b42dcaa7686cef7e$var$ensureStatusModal() {
    const overlayModal = document.getElementById("klaviyo-status-modal");
    if (overlayModal) return;
    const ksmModal = document.querySelector(".ksm-modal");
    if (!ksmModal) return;
    const overlay = document.createElement("div");
    overlay.className = "ksm-overlay";
    overlay.id = "klaviyo-status-modal";
    overlay.setAttribute("role", "dialog");
    overlay.setAttribute("aria-modal", "true");
    const ksmModalClone = ksmModal.cloneNode(true);
    ksmModalClone.removeAttribute("hidden");
    overlay.appendChild(ksmModalClone);
    overlay.addEventListener("click", (e)=>{
        if (e.target === overlay) $b42dcaa7686cef7e$var$closeStatusModal();
    });
    const closeBtn = overlay.querySelector('[data-action="close"]');
    if (closeBtn) closeBtn.addEventListener("click", $b42dcaa7686cef7e$var$closeStatusModal);
    document.body.appendChild(overlay);
}
function $b42dcaa7686cef7e$var$openStatusModal(title, message, state = "loading") {
    const overlay = document.getElementById("klaviyo-status-modal");
    if (!overlay) return;
    $b42dcaa7686cef7e$var$updateStatusModal(title, message, state);
    overlay.style.display = "flex";
}
function $b42dcaa7686cef7e$var$updateStatusModal(title = "", message = "", state = "loading") {
    const overlay = document.getElementById("klaviyo-status-modal");
    if (!overlay) return;
    const titleEl = overlay.querySelector(".ksm-title");
    const msgEl = overlay.querySelector(".ksm-message");
    const statusEl = overlay.querySelector(".ksm-status-indicator");
    if (titleEl) titleEl.textContent = title || "";
    if (msgEl) msgEl.textContent = message || "";
    if (statusEl) {
        statusEl.classList.remove("success", "error", "loading", "ksm-status-success", "ksm-status-error", "ksm-status-loading");
        statusEl.classList.add(state);
    }
}
function $b42dcaa7686cef7e$var$closeStatusModal() {
    const overlay = document.getElementById("klaviyo-status-modal");
    if (!overlay) return;
    overlay.style.display = "none";
}


if (!customElements.get("mix-and-match")) {
    class MixAndMatch extends HTMLElement {
        constructor(){
            super();
        }
        get mainContainer() {
            return this.closest("[data-mix-and-match]");
        }
        get productTemplate() {
            return this.querySelector("template");
        }
        get productsContainer() {
            return this.querySelector("[data-mix-and-match-products-list]");
        }
        get progressBar() {
            return this.querySelector(".mix-and-match-progress-bar");
        }
        get mixAndMatchProducts() {
            const script = this.querySelector('script[type="application/json"]');
            return script ? JSON.parse(script.innerHTML) : [];
        }
        get getMixAndMatchModal() {
            return document.querySelector("modal-dialog#PopupModal-mix-and-match");
        }
        async connectedCallback() {
            await this.updateMixAndMatch();
            await this.onCartUpdate();
        }
        getSectionInnerHTML(html, selector) {
            return new DOMParser().parseFromString(html, "text/html").querySelector(selector).innerHTML;
        }
        async updateMixAndMatch() {
            const addedProducts = await this.getAddedProducts();
            if (addedProducts.length < 1) {
                this.classList.add("no-products");
                if (this.mainContainer) this.mainContainer.classList.remove("mix-and-match");
            } else {
                this.classList.remove("no-products");
                if (this.mainContainer) this.mainContainer.classList.add("mix-and-match");
                this.buildEmptyProductVariants();
                await this.buildProductVariants(addedProducts);
                await this.updateProgressBar(addedProducts);
            }
        }
        async updateMixAndMatchPopup() {
            const modalIsOpen = this.getMixAndMatchModal?.hasAttribute("open");
            if (!modalIsOpen) {
                const productCards = this.getMixAndMatchModal.querySelectorAll("product-card");
                productCards.forEach((productCard)=>{
                    productCard.connectedCallback();
                });
            }
        }
        async getAddedProducts() {
            const cartItems = await this.getCartItems();
            return cartItems.filter((item)=>{
                const itemProperties = item.properties;
                if (!itemProperties) return;
                const wasItAddedInMixAndMatch = itemProperties["_mix_match_enabled"];
                if (!wasItAddedInMixAndMatch) return;
                const wasItAddedInMixAndMatchVal = wasItAddedInMixAndMatch === "true" || false;
                if (!wasItAddedInMixAndMatchVal) return;
                return item;
            }).filter((item)=>this.mixAndMatchProducts.some((product)=>product.id === item.product_id)).map((item)=>{
                let productSubtext = "";
                const cartDrawer = document.getElementById("Cart-Drawer");
                if (cartDrawer) {
                    const lineItem = cartDrawer.querySelector(`.product-cart-item[data-id="${item.id}"]`);
                    if (lineItem) productSubtext = lineItem.dataset.subtext;
                }
                return {
                    id: item.id,
                    key: item.key,
                    product_id: item.product_id,
                    title: item.product_title,
                    price: item.price,
                    discounted_price: item.discounted_price,
                    image: item.image,
                    handle: item.handle,
                    quantity: item.quantity,
                    subtext: productSubtext
                };
            });
        }
        async getCartItems() {
            try {
                const response = await fetch("/cart.js");
                if (!response.ok) throw new Error("Failed to fetch cart");
                const cart = await response.json();
                return cart.items || [];
            } catch (error) {
                console.error("Error fetching cart:", error);
                return [];
            }
        }
        buildEmptyProductVariants() {
            const fragment = document.createDocumentFragment();
            this.productsContainer.innerHTML = "";
            for(let index = 0; index < 3; index++){
                const product = this.productTemplate.content.cloneNode(true);
                fragment.appendChild(product);
            }
            this.productsContainer.appendChild(fragment);
        }
        async buildProductVariants(addedProducts) {
            const fragment = document.createDocumentFragment();
            this.productsContainer.innerHTML = "";
            let totalAppended = 0;
            let format = window.theme.settings.money_with_currency_format || "{{amount}} kr.";
            addedProducts.forEach((product)=>{
                const productTemplate = this.productTemplate.content.cloneNode(true);
                if (!productTemplate) return;
                const productWrapper = productTemplate.querySelector(".mix-and-match-product");
                const productImage = productTemplate.querySelector(".mix-and-match-product-image > img");
                const productTitle = productTemplate.querySelector(".mix-and-match-product-title");
                const productPrice = productTemplate.querySelector(".mix-and-match-product-price");
                const productDiscountedPrice = productTemplate.querySelector(".mix-and-match-product-discounted-price");
                const productCheckmark = productTemplate.querySelector("button.mix-and-match-checkmark");
                const productQuantity = productTemplate.querySelector(".mix-and-match-product-quantity");
                const productUpsellHeading = productTemplate.querySelector(".mix-and-match-product-description-bottom");
                try {
                    if (productCheckmark) productCheckmark.addEventListener("click", async ()=>{
                        if (productWrapper) productWrapper.classList.add("mix-and-match-product-disabled");
                        dispatchCustomEvent("line-item:change:start", {
                            quantity: 0
                        });
                        fetch(theme.routes.cart_change_url, {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                                Accept: "application/json"
                            },
                            body: JSON.stringify({
                                id: product.key,
                                quantity: 0,
                                sections: this.getSectionsToRender().map((section)=>section.section),
                                sections_url: window.location.pathname
                            })
                        }).then((response)=>{
                            if (response.ok && productWrapper) productWrapper.classList.remove("mix-and-match-product-disabled");
                            return response.json();
                        }).then(async (parsedState)=>{
                            let isCartDrawerInitialized = false;
                            this.getSectionsToRender().forEach((section)=>{
                                const elementToReplace = document.getElementById(section.id)?.querySelector(section.selector) || document.getElementById(section.id);
                                if (elementToReplace && parsedState && parsedState.sections && parsedState.sections[section.section]) {
                                    elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
                                    if (typeof CartDrawer !== "undefined") {
                                        if (!isCartDrawerInitialized) {
                                            new CartDrawer();
                                            isCartDrawerInitialized = true;
                                        }
                                    }
                                }
                            });
                            dispatchCustomEvent("line-item:change:end", {
                                quantity: 0,
                                cart: parsedState
                            });
                        });
                    });
                } catch (error) {
                    console.error("Error building product variant:", error);
                }
                if (productImage) productImage.src = product.image;
                if (productTitle) productTitle.textContent = product.title;
                if (productPrice) productPrice.textContent = formatMoney(product.price, format);
                if (productQuantity) {
                    if (product.quantity > 1) {
                        productQuantity.classList.remove("is-hidden");
                        productQuantity.textContent = `x ${product.quantity}`;
                    } else {
                        productQuantity.classList.add("is-hidden");
                        productQuantity.textContent = "";
                    }
                }
                if (productDiscountedPrice) {
                    if (product.discounted_price !== product.price) {
                        if (productPrice) productPrice.classList.add("mix-and-match-product-price--discounted");
                        productDiscountedPrice.textContent = formatMoney(product.discounted_price, format);
                        productDiscountedPrice.classList.remove("is-hidden");
                    } else productDiscountedPrice.classList.add("is-hidden");
                }
                if (productUpsellHeading) {
                    if (product.subtext) {
                        productUpsellHeading.classList.remove("is-hidden");
                        productUpsellHeading.textContent = product.subtext;
                    } else productUpsellHeading.classList.add("is-hidden");
                }
                if (productWrapper) productWrapper.classList.remove("no-product");
                fragment.appendChild(productTemplate);
                totalAppended++;
            });
            while(totalAppended < 3){
                const emptyProduct = this.productTemplate.content.cloneNode(true);
                fragment.appendChild(emptyProduct);
                totalAppended++;
            }
            this.productsContainer.appendChild(fragment);
        }
        getSectionsToRender() {
            return [
                {
                    id: "Cart",
                    section: "main-cart",
                    selector: ".thb-cart-form"
                },
                {
                    id: "Cart-Drawer",
                    section: "cart-drawer",
                    selector: ".cart-drawer"
                },
                {
                    id: "cart-drawer-toggle",
                    section: "cart-bubble",
                    selector: ".thb-item-count"
                },
                {
                    id: "PopupModal-mix-and-match",
                    section: "mix-and-match-drawer",
                    selector: ".mix-and-match-modal__content-info-list"
                }
            ];
        }
        async updateProgressBar(addedProducts) {
            const quantity = Math.min(3, addedProducts.reduce((acc, variant)=>acc + variant.quantity, 0));
            const progressBarLabels = this.progressBar.querySelectorAll(".mix-and-match-progress-bar-label");
            progressBarLabels.forEach((label)=>{
                label.classList.remove("active");
                const activeLabel = label.hasAttribute(`data-progress-${quantity}`);
                if (activeLabel) label.classList.add("active");
            });
        }
        async onCartUpdate() {
            if (this._fetchIntercepted) return;
            this._fetchIntercepted = true;
            const _this = this;
            (function() {
                const originalFetch = window.fetch;
                window.fetch = async function(...args) {
                    const response = await originalFetch.apply(this, args);
                    if (args[0].includes("/cart/")) {
                        await _this.updateMixAndMatch();
                        await _this.updateMixAndMatchPopup();
                    }
                    return response;
                };
            })();
        }
    }
    customElements.define("mix-and-match", MixAndMatch);
}


document.addEventListener("DOMContentLoaded", ()=>{
    const addToCartButton = document.getElementById("AddToCart");
    const stickyAddToCart = document.querySelector("product-add-to-cart-sticky");
    if (!addToCartButton || !stickyAddToCart) {
        console.warn("Required elements not found");
        return;
    }
    stickyAddToCart.style.display = "none";
    const observer = new IntersectionObserver((entries)=>{
        const entry = entries[0];
        if (entry.isIntersecting) stickyAddToCart.style.display = "none";
        else stickyAddToCart.style.display = "block";
    }, {
        threshold: 0,
        rootMargin: "0px"
    });
    observer.observe(addToCartButton);
    window.addEventListener("beforeunload", ()=>{
        observer.disconnect();
    });
});


document.addEventListener("DOMContentLoaded", ()=>{
    const storeName = document.querySelector("[store-name]")?.getAttribute("store-name");
    if (storeName !== "rslt") return;
    const bigImage = document.querySelector(".product-images--big-image .product-images__slide:first-child img");
    const updatedThumbnails = document.querySelectorAll(".product-thumbnail img");
    updatedThumbnails.forEach((thumbnail)=>{
        thumbnail.addEventListener("click", ()=>{
            const productImagesSlidesAll = document.querySelectorAll(".product-images__slide");
            productImagesSlidesAll.forEach((productImagesSlide)=>{
                productImagesSlide.classList.remove("is-active-slide");
            });
            const productSlide = thumbnail.closest(".product-images__slide");
            productSlide.classList.add("is-active-slide");
            bigImage.src = thumbnail.src;
            bigImage.srcset = thumbnail.srcset || "";
            bigImage.alt = thumbnail.alt;
        });
    });
});


document.addEventListener("DOMContentLoaded", function() {
    const toggleButton = document.getElementById("toggle-description-btn");
    if (toggleButton) toggleButton.addEventListener("click", function() {
        const container = toggleButton.closest(".product-short-description");
        const descriptionContent = container.querySelector(".description-content");
        const seeMoreText = toggleButton.getAttribute("data-see-more");
        const seeLessText = toggleButton.getAttribute("data-see-less");
        if (descriptionContent.classList.contains("expanded")) {
            descriptionContent.classList.remove("expanded");
            toggleButton.textContent = seeMoreText;
        } else {
            descriptionContent.classList.add("expanded");
            toggleButton.textContent = seeLessText;
        }
    });
});


parcelRequire("ilxwZ");
document.addEventListener("recommendations-loaded", function() {
    const recommendedProducts = document.querySelectorAll(".recommended-product");
    recommendedProducts.forEach((product)=>{
        product.querySelector(".product-card--add-to-cart-button").addEventListener("click", function() {
            gtag("event", "add_to_cart_recommendation", {
                productId: product.dataset.productId,
                quantity: 1,
                add_to_cart_recommendation_quantity: 1
            });
        });
        product.querySelector(".product-cart-item-image").addEventListener("click", function() {
            gtag("event", "view_product_recommendation", {
                productId: product.dataset.productId
            });
        });
    });
});



})();
//# sourceMappingURL=parcel_scripts.js.map
